module.exports = __webpack_public_path__ + "statics/img/income-card-1.3dc50986.png";